import { render, staticRenderFns } from "./limitsView.vue?vue&type=template&id=4f273483&scoped=true&"
import script from "./limitsView.vue?vue&type=script&lang=js&"
export * from "./limitsView.vue?vue&type=script&lang=js&"
import style0 from "./limitsView.vue?vue&type=style&index=0&id=4f273483&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f273483",
  null
  
)

export default component.exports